import {
  FETCH_BROKER_FIRM_OWNERS_FAILURE,
  FETCH_BROKER_FIRM_OWNERS_REQUEST,
  FETCH_BROKER_FIRM_OWNERS_SUCCESS
} from '../../actions/broker/types';

/**
 *
 * @type FetchBrokerFirmsState
 */
const initialState = {
  loading: false,
  data: null,
  error: null
};

/**
 *
 *
 *
 * @typedef {Object} ACTION
 * @property {string} type
 * @property {Array<*>} [payload]
 * @property {string} [error]
 *
 *
 *
 * @param { FetchBrokerFirmsState} state
 * @param {ACTION} action
 * @param {*} type
 *
 * @return {FetchBrokerFirmsState}
 */
const BrokerOwner = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BROKER_FIRM_OWNERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_BROKER_FIRM_OWNERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };
    }

    case FETCH_BROKER_FIRM_OWNERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
};

/**
 * @type {BrokerOwnerStoreState}
 */
export const BrokerOwnerState = (state) => state.brokerOwner;

export default BrokerOwner;
